import React, {useState} from "react";
import {Box, useTheme} from "@mui/material";
import {Computer, Gauge, LayoutDashboard, Package} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {PageHeader} from "../../../shared/ui";

// A casca das telas de planos: barra, menu lateral e a área principal.
export default function PlanosLayout({openParent = true, children}) {
    const theme = useTheme();
    const navigate = useNavigate();
    const [open, setOpen] = useState(openParent);

    const menus = [
        {label: "Dashboard", id: "dashboard", selected: false, disabled: false, icon: <LayoutDashboard size={20} />, onClick: () => navigate("/")},
        {label: "Sistemas", id: "sistemas", selected: false, disabled: false, icon: <Computer size={20} />, onClick: () => navigate("/sistemas")},
        {label: "Métricas", id: "metricas", selected: false, disabled: false, icon: <Gauge size={20} />, onClick: () => navigate("/metricas")},
        {label: "Planos Comerciais", id: "planos", selected: true, disabled: false, icon: <Package size={20} />, onClick: () => navigate("/planos-comerciais")},
    ];

    return (
        <Box sx={{display: 'flex', minHeight: '100dvh'}}>
            <PageHeader
                title="Planos Comerciais"
                subtitle=""
                titleAction={() => navigate("/")}
                itemsMenu={menus}
                onHandleMenuOpen={() => null}
                onHandleDrawerToggle={setOpen}
                openParent={open}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: {xs: 2, md: 6},
                    minWidth: 0,
                    boxSizing: 'border-box',
                    transition: theme.transitions.create(['margin', 'width'], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                    mt: 8,
                    backgroundColor: theme.palette.background.default,
                    minHeight: 'calc(100dvh - 64px)',
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
